export const adminPanelText = {
  title: 'General Stats',
  activeUsers: 'Active Users: ',
  workspacesAmount: 'Workspaces Amount: ',
  coursesAmount: 'Courses Amount: ',
  publicCoursesAmount: 'Public Courses Amount: ',
  logout: 'Logout',
  workspaceVisits: 'Workspace Visits',
  recentSignups: 'Recent Sign-Ups',

  // Studio costs: what Tapybl pays its AI providers and render servers, in USD. Authors and
  // workspaces never see these amounts.
  studioCosts: 'Studio costs',
  studioCostsNote:
    'What Microreel Studio cost Tapybl in AI providers and render servers, in USD. Workspaces never see these amounts.',
  from: 'From',
  to: 'To',
  refresh: 'Refresh',
  loadingCosts: 'Loading Studio costs…',
  rangeReversed: 'Choose a start date on or before the end date.',
  rangeTooLong: (days: number) => `Choose a range of at most ${days} days.`,
  rangeOverClockChange: (days: number) =>
    `Choose a shorter range: the clocks go back an hour in this one, which makes it longer than ${days} days.`,
  costsForbidden: 'Only SuperAdmins can see Studio costs.',
  costsUnavailable: "This API doesn't report Studio costs yet.",
  costsFailed: 'Could not load Studio costs. Try again.',
  costsInvalid: 'The API could not report Studio costs for these dates.',
  noCosts: 'No Studio costs were recorded in this period.',

  aiCost: 'AI cost: ',
  computeCost: 'Compute cost: ',
  totalCost: 'Total: ',
  fleetCost: 'Render fleet cost: ',
  unattributedCost:
    'Unattributed (recorded before costs had a stage or reason): ',
  unknownCostReceipts: 'Calls with an unknown cost (not in any amount): ',
  claimPricedReceipts: 'Calls priced at the estimate (outcome never saved): ',
  initialCost: 'Initial generation: ',
  regenerationCost: 'Regenerations and edits: ',
  shareOfAttributed: (percent: number) => ` (${percent}% of attributed cost)`,

  byStage: 'Cost by stage',
  byReason: 'Cost by reason',
  byModel: 'Cost by model',
  jobs: 'Jobs',
  aiCostColumn: 'AI cost',
  computeCostColumn: 'Compute cost',
  stage: 'Stage',
  reason: 'Reason',
  model: 'Model',
  cost: 'Cost',
  calls: 'Calls',
  usage: 'Usage',
  job: 'Job',
  renders: 'Renders',
  costPerMicroreel: 'Cost per microreel',
  details: 'Details',
  hideDetails: 'Hide',
  unattributed: 'Unattributed',
  untitled: 'Untitled job',
  workspaceId: (id: string) => `Workspace ${id}`,
  noRows: 'None',
  unknownCost: (count: number) =>
    `${count} unknown ${count === 1 ? 'cost' : 'costs'}`,
  microreels: (count: number) =>
    `${count} ${count === 1 ? 'microreel' : 'microreels'}`,
  microreelsWithCosts: (count: number) =>
    `costs on ${count} ${count === 1 ? 'microreel' : 'microreels'}`,
  render: (number: number) => `Render ${number}`,
  byRender: 'By render',
  byReel: 'By microreel',
  credits: (charged?: number, held?: number) =>
    [
      charged !== undefined ? `${charged.toLocaleString('en-US')} charged` : '',
      held ? `${held.toLocaleString('en-US')} held` : '',
    ]
      .filter(Boolean)
      .join(', '),
  creditsLabel: 'Credits: ',
  tokens: (count: number) => `${count.toLocaleString('en-US')} tokens`,
  characters: (count: number) => `${count.toLocaleString('en-US')} characters`,
  images: (count: number) =>
    `${count.toLocaleString('en-US')} ${count === 1 ? 'image' : 'images'}`,
  vcpuSeconds: (seconds: number) =>
    `${seconds.toLocaleString('en-US', {maximumFractionDigits: 1})} vCPU-s`,
};
